import { Tab } from '@mui/material';
import { useState } from 'react';

import { PermissionsEnum } from '@/auth/interfaces';
import { CustomTabPanel } from '@/erp/sale';
import { a11yProps, useCheckPermissions } from '@/shared';
import {
  FormTabsOnly,
  SingleBoxTableTabsOnly,
  SingleTableBoxScene,
} from '@/shared/components/ui';
import FotosActualizacionPendienteOTTecnico from './FotosActualizacionPendienteOTTecnico';
import FotosEntradaPendingTecOTInstall from './FotosEntradaPendingTecOTInstall';
import FotosSalidaPendingTecOTInstall from './FotosSalidaPendingTecOTInstall';

export type FotosInstallTecnicoOTMainPageProps = {};

const FotosInstallTecnicoOTMainPage: React.FC<
  FotosInstallTecnicoOTMainPageProps
> = () => {
  useCheckPermissions(PermissionsEnum.api_view_ordentrabajo);

  const [valueTab, setValueTab] = useState(1);
  const handleMethodChange = (_event: any, newValue: number) => {
    setValueTab(newValue);
  };

  return (
    <SingleTableBoxScene title={'Fotos de Instalación'}>
      <SingleBoxTableTabsOnly>
        <FormTabsOnly onChange={handleMethodChange} value={valueTab}>
          <Tab label={'Fotos Ingreso Pendiente'} value={1} {...a11yProps(1)} />
          <Tab label={'Fotos Salida Pendiente'} value={2} {...a11yProps(2)} />

          <Tab
            label={'Fotos Pendiente Actualización'}
            value={3}
            {...a11yProps(3)}
          />
        </FormTabsOnly>
      </SingleBoxTableTabsOnly>

      {/* ============ Fotos Ingreso ============ */}
      <CustomTabPanel value={valueTab} index={1}>
        <FotosEntradaPendingTecOTInstall />
      </CustomTabPanel>

      {/* ============ Fotos Salida ============ */}
      <CustomTabPanel value={valueTab} index={2}>
        <FotosSalidaPendingTecOTInstall />
      </CustomTabPanel>

      {/* ============ actualización pendiente ============ */}
      <CustomTabPanel value={valueTab} index={3}>
        <FotosActualizacionPendienteOTTecnico />
      </CustomTabPanel>
    </SingleTableBoxScene>
  );
};

export default FotosInstallTecnicoOTMainPage;
